var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';
import ShareItem from './shareItem';
import { displayTypes } from './displayTypes';
import { supportedCommunities } from './supportedCommunities';
import { map } from 'd3-collection';
import shareActionFactory from '@ta-interaktiv/share-url-factory';


// region CSS
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css';
import '../style/styles.css';
// endregion

/**
 * Renders social sharing buttons.
 * @param {ShareButtonsProps} props
 * @param [props.displayType=VERTICAL_BUTTONS] - The display
 * type, see {@link displayTypes}
 * @param [props.inverted=false] - For displaying the list on a dark
 * background.
 * @param [props.communities] - Community objects, as
 * provided by the External Services API service by Newsnet.
 * @param [props.hashtags] - Hashtags as an array of strings.
 * Facebook  will only use the first one.
 * @param [props.url=window.location.href] - The URL to share.
 * @param [props.clickHandler=noop] - The action that should be
 *   executed when the user clicks the link. The communities object is bound to
 *   this action, so that the type (or other infos) can be extracted from it.
 *   This design also means that in case of an API change the changes can be
 *   executed on the level of the polymorphic component.
 * @param [props.className] - Additional class names to be passed to the link
 * group.
 * @param [props.itemClassName] - Additional class names to be passed into
 * individual items.
 * @param [props.additionalFacebookShares] - In case of Facebook share loss
 * (e.g. when the canonical URL has been changed), you can provide
 * additional shares via this property.
 * @constructor
 */
export function ShareButtons(_ref) {
  var _ref$displayType = _ref.displayType,
      displayType = _ref$displayType === undefined ? displayTypes.VERTICAL_BUTTONS : _ref$displayType,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === undefined ? false : _ref$inverted,
      _ref$communities = _ref.communities,
      communities = _ref$communities === undefined ? [{
    type: 'twitter',
    article_id: '-1',
    refresh: '-1',
    share_type_id: '-1',
    description: 'Bei Twitter veröffentlichen',
    count: 0,
    cache: 'false'
  }, {
    type: 'facebook',
    description: 'Auf Facebook teilen',
    facebook_id: '147124108642216',
    count: 0,
    article_id: '-1',
    refresh: '-1',
    share_type_id: '-1',
    cache: 'false'
  }, {
    type: 'whatsapp',
    description: 'Über WhatsApp texten',
    count: 0,
    article_id: '-1',
    refresh: '-1',
    share_type_id: '-1',
    cache: 'false'
  }, {
    type: 'share',
    description: 'Per Mail senden',
    count: 0,
    article_id: '-1',
    refresh: '-1',
    share_type_id: '-1',
    cache: 'false'
  }] : _ref$communities,
      hashtags = _ref.hashtags,
      _ref$url = _ref.url,
      url = _ref$url === undefined ? window.location.href.replace(window.location.search, '').replace(window.location.hash, '') : _ref$url,
      _ref$clickHandler = _ref.clickHandler,
      clickHandler = _ref$clickHandler === undefined ? function () {} : _ref$clickHandler,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$itemClassName = _ref.itemClassName,
      itemClassName = _ref$itemClassName === undefined ? '' : _ref$itemClassName,
      _ref$additionalFacebo = _ref.additionalFacebookShares,
      additionalFacebookShares = _ref$additionalFacebo === undefined ? 0 : _ref$additionalFacebo;

  // Set up group class, depending on the desired display type.
  var groupClass = 'ta sharing ui ' + className;

  switch (displayType) {
    case displayTypes.HORIZONTAL_ICONS:
      groupClass += ' horizontal link list';
      break;

    case displayTypes.VERTICAL_BUTTONS:
      groupClass += ' vertical labeled small icon buttons';
      break;

    case displayTypes.HORIZONTAL_BUTTONS:
      groupClass += ' icon basic buttons';
  }

  // Add "inverted" if necessary
  if (inverted) {
    groupClass += ' inverted';
  }

  // Prepare Communities array
  var mappedCommunities = map(communities, function (d) {
    return d.type;
  });

  return React.createElement(
    'div',
    { className: groupClass },
    supportedCommunities.map(function (communityType) {
      var community = mappedCommunities.get(communityType);
      if (community === undefined) {
        return;
      }

      var count = community.count;

      // region Special cases

      // Mail has it's mail share URL already set up, so we need
      // to take that into account. Unless it has not been set up, of course
      var shareUrl = url;
      if (communityType === 'share') {
        if (community.url === undefined) {
          shareUrl = 'mailto:?subject=' + window.document.title + '&body=' + url;
        } else {
          shareUrl = community.url;
        }
      }

      if (communityType === 'facebook') {
        count += additionalFacebookShares;
      }

      // endregion

      // Create clone of the original function and bind the community
      // object to it, so we can refer to that higher in the hierarchy.
      var onClickHandler = clickHandler.bind(null, community);

      return React.createElement(ShareItem, _extends({
        key: communityType
      }, community, {
        displayType: displayType,
        inverted: inverted,
        onClick: onClickHandler,
        className: itemClassName,
        shareUrl: shareActionFactory[communityType](_extends({
          hashtags: hashtags
        }, community, {
          url: shareUrl
        })),
        count: count
      }));
    })
  );
}

export default ShareButtons;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-share-buttons/es/shareButtons.js
// module id = null
// module chunks = 